import React from 'react';
import { connect } from 'react-redux';
import config from '../../../config/config';
import { bindActionCreators, compose } from 'redux';
import Case from '../../Shared/Switch/Case';
import If from '../../Shared/If/If';
import Switch from '../../Shared/Switch/Switch';
import ToolTip from '../ToolTip/ToolTip';
import {
  BUY_TRANSACTION,
  SELL_TRANSACTION,
  EXCHANGE_TRANSACTION,
  transactionType,
} from '../../../utils/transactions-util';
import {
  getHasAutoExchanges,
  getHasRecurringPurchases,
  getHasRecurringRedemptions,
} from '../../../redux/modules/automaticInvestments/automaticInvestments.selectors';
import recurringFlag from '../../../assets/images/recurring-icon.svg';
import {
  getSystematicExchanges,
  getSystematicPurchases,
  getSystematicRedemptions,
} from '../../../redux/modules/automaticInvestments/automaticInvestments.module';

import './RecurringFlag.scss';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';

const RecurringFlag = ({ isSalesforceRep, customerWebViewEnabled, fund }) => {
  const recurringTransaction = 'Recurring Transaction';
  return (
    <div className={`e2e-recurring-flag recurring-flag`}>
      <Switch test={transactionType()}>
        <Case value={BUY_TRANSACTION}>
          <If test={fund.hasRecurring}>
            <span>
              <img
                alt="recurring"
                className="recurring-flag-icon"
                src={recurringFlag}
              />
            </span>
            <ToolTip
              callerText={'Recurring'}
              header={recurringTransaction}
              message={
                <div className="exclude">
                  A recurring transaction is linked to this fund.{' '}
                  {!customerWebViewEnabled && isSalesforceRep ? (
                    <span>
                      Check with the client to ensure existing instructions do
                      not need to be amended. To edit or remove this
                      instruction, close this tool and visit Automatic
                      Transactions flow.
                    </span>
                  ) : (
                    <span>
                      To edit or remove, visit{' '}
                      <a
                        target="_blank"
                        className="exclude"
                        rel="noopener noreferrer"
                        href={`${config.url}/usis/transactions/automatic`}
                      >
                        Automatic Transactions
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>
        </Case>
        <Case value={SELL_TRANSACTION}>
          <If test={fund.hasRecurring}>
            <span>
              <img
                alt="recurring"
                className="recurring-flag-icon"
                src={recurringFlag}
              />
            </span>
            <ToolTip
              callerText={'Recurring'}
              header={recurringTransaction}
              message={
                <div>
                  A recurring transaction is linked to this fund.{' '}
                  {!customerWebViewEnabled && isSalesforceRep ? (
                    <span>
                      Check with the client to ensure existing instructions do
                      not need to be amended. To edit or remove this
                      instruction, close this tool and visit Automatic
                      Transactions flow.
                    </span>
                  ) : (
                    <span>
                      To edit or remove, visit{' '}
                      <a
                        target="_blank"
                        className="exclude"
                        rel="noopener noreferrer"
                        href={`${config.url}/usis/transactions/automatic`}
                      >
                        Automatic Transactions
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>
        </Case>
        <Case value={EXCHANGE_TRANSACTION}>
          <If test={fund.hasRecurring}>
            <span>
              <img
                alt="recurring"
                className="recurring-flag-icon"
                src={recurringFlag}
              />
            </span>
            <ToolTip
              callerText={'Recurring'}
              header={recurringTransaction}
              message={
                <div>
                  A recurring transaction is linked to this fund.{' '}
                  {!customerWebViewEnabled && isSalesforceRep ? (
                    <span>
                      Check with the client to ensure existing instructions do
                      not need to be amended. To edit or remove this
                      instruction, close this tool and visit Automatic
                      Transactions flow.
                    </span>
                  ) : (
                    <span>
                      To edit or remove, visit{' '}
                      <a
                        target="_blank"
                        className="exclude"
                        rel="noopener noreferrer"
                        href={`${config.url}/usis/transactions/automatic`}
                      >
                        Automatic Transactions
                      </a>
                    </span>
                  )}
                </div>
              }
            />
          </If>
        </Case>
      </Switch>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    hasAutoExchanges: getHasAutoExchanges(state),
    hasRecurringPurchases: getHasRecurringPurchases(state),
    hasRecurringRedemptions: getHasRecurringRedemptions(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  recurringActions: bindActionCreators(
    {
      getSystematicExchanges,
      getSystematicPurchases,
      getSystematicRedemptions,
    },
    dispatch
  ),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  RecurringFlag
);
